import React from "react";

export interface AdminTenantsPaginationProps {
  total: number;
  page: number;
  totalPages: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
  /** test-id prefix; defaults to "admin-tenants" so this can be reused on other admin tables. */
  testIdPrefix?: string;
}

const LIMIT_OPTIONS = [25, 50, 100, 200];

/**
 * Pagination controls for AdminTenants/AdminTenantDeletions tables.
 * - aria-label on prev/next buttons for SR accessibility.
 */
export const AdminTenantsPagination: React.FC<AdminTenantsPaginationProps> = ({
  total,
  page,
  totalPages,
  limit,
  onPageChange,
  onLimitChange,
  testIdPrefix = "admin-tenants",
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="text-sm text-neutral-600">
        Łącznie: {total} | Strona {page} z {totalPages}
      </div>
      <div className="flex gap-2 items-center">
        <label className="text-sm text-neutral-600">
          Na stronę:&nbsp;
          <select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            data-testid={`${testIdPrefix}-limit`}
            className="border border-neutral-300 rounded-md px-2 py-1 text-sm"
          >
            {LIMIT_OPTIONS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          data-testid={`${testIdPrefix}-prev`}
          aria-label="Poprzednia strona"
          className="rounded-md border border-neutral-300 bg-white px-3 py-1 text-sm disabled:opacity-40"
        >
          ← Poprzednia
        </button>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid={`${testIdPrefix}-next`}
          aria-label="Następna strona"
          className="rounded-md border border-neutral-300 bg-white px-3 py-1 text-sm disabled:opacity-40"
        >
          Następna →
        </button>
      </div>
    </div>
  );
};

export default AdminTenantsPagination;
